import { render } from "./addContent.vue?vue&type=template&id=6412e726"
import script from "./addContent.vue?vue&type=script&lang=js"
export * from "./addContent.vue?vue&type=script&lang=js"

import "./addContent.vue?vue&type=style&index=0&id=6412e726&lang=less"
script.render = render

export default script